<template>
    <section id="welcome-title">
      <h2>Marinka Grondel</h2>
    </section>
  <div id="intro-container" v-if="entryImage" @click="$router.push('/nour')">
      <div class="img-container" @mouseenter="startReflection($event)" @mouseleave="stopReflection($event)">
        <ImageLoader class="image1" :small="$store.state.$imageBaseURL + entryImage.id + '/' + entryImage.cover1 + '?w=32&q=50&dpr=2&token=' + $store.state.$imageToken" :trueSize="$store.state.$imageHackURL + entryImage.id + '/' + entryImage.cover1"/>

        <ImageLoader class="image2" :small="$store.state.$imageBaseURL + entryImage.id + '/' + entryImage.cover2 + '?w=32&q=50&dpr=2&token=' + $store.state.$imageToken" :trueSize="$store.state.$imageHackURL + entryImage.id + '/' + entryImage.cover2"/>
      </div>
  </div>
</template>


<script>
import ImageLoader from '../components/ImageLoader.vue'

export default {
  components: {
    ImageLoader
  },
  data() {
    return {
      entryImage: null
    }
  },
  mounted() {
    this.fetchContent();
  },
  methods: {
    fetchContent() {
      fetch(`https://marinkagrondel.com/cms/api/entries?id=intro-page/image&token=${process.env.VUE_APP_ENTRY_TOKEN}`)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not OK');
      } else {
        response.json()
          .then((JSON) => {
              // convert Object to Array !!!
              // const entries = Object.values(JSON.data);
              this.entryImage = JSON.data;
          })
      }
    })
    },
    startReflection(e) {
      let gradientEl = document.createElement("DIV");
      gradientEl.classList.add("nour-gradient");
      e.target.appendChild(gradientEl);

      e.target.addEventListener('mousemove', (e) => {
        this.cursorPos(e, gradientEl)
      });
      e.target.style.backgroundColor = 'grey';
      gradientEl.style.opacity = 1;
    },
    stopReflection(e) {
      let gradientEl = document.getElementsByClassName("nour-gradient")[0];
      e.target.removeChild(gradientEl);
      e.target.style.backgroundColor = 'unset';
    },
    cursorPos(event, el) {
      let rect = event.target.getBoundingClientRect();
      var x = event.clientX - rect.left;
      el.style.transform = "translateX(" + (x - (rect.width / 2)) + "px)";
    }
  }

}
</script>

<style>
#intro-container {
  position: absolute;
  top: 0;
  width:100%;
  height: 100%;
  background-color: var(--nour-bg-color);
  cursor: pointer;
  display:flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}

#welcome-title {
  position: absolute;
  left: 50%;
  bottom: 50%;
  transform: translateX(-50%);
  margin: 0 auto;
  margin-right: 2em;
  z-index: 40;
  text-align: center;
  pointer-events: none;
  width: 100%;
  user-select: none;
}

#welcome-title h2 {
  font-size: 50px;
  color: #dfdede;
  font-family: 'secondary', sans-serif !important;
    letter-spacing: -0.7px;
  line-height: 0.9;
  transition: all 1s;
  opacity: 0.6;
}

#app:hover #welcome-title h2 {
  color: #dfdede !important;
  opacity: 1;
}


#intro-container .img-container {
  height:100%;
  width: 100%;
  position:relative;
  overflow:hidden;
  flex-shrink: 0;
  flex-grow: 1;
  transition: background-color 0.5s;
}

#intro-container .img-container .image1 {
  z-index: 50;
}

#intro-container .img-container .image2 {
  z-index: 10;
}

.nour-gradient {
  position:absolute;
  top:0;
  margin:0;
  padding:0;
  width:100%;
  height:100%;
  background-image: url('../assets/reflection.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 80% 50%;
  z-index:0;
  opacity: 0;
  will-change: transform;
}

#intro-container .img-container img {
  object-fit: cover;
  bottom:0;
  width:100%;
  height:100%;
}

.image1, .image2 {
  top:0px;
  left:0px;
}

.image1 {
  position:relative;
  z-index:5;
}

.image2 {
  position:absolute;
  z-index:10;
}

#intro-container .image1 {
  opacity: 1;
}

#intro-container:hover .image1 {
  opacity: 0.85 !important;
}

#intro-container .image2 {
  opacity:1;
  mix-blend-mode: lighten;
}

.fade-enter-active {
  mix-blend-mode: multiply;
  transition: opacity 0.2s ease 0.3s;
}
.fade-leave-active {
  mix-blend-mode: multiply;
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 900px){
  #welcome-title h2 {
    font-size: 1.8rem;
  }

  #welcome-title {
    margin-right:0;
    top: 50%;
      right: unset;
      left: 50%;
      transform: translateY(-50%) translateX(-50%);
  }
  
}

</style>